module.exports = __webpack_public_path__ + "static/img/boy.9247fb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/boy.png
// module id = 18fx
// module chunks = 1